<div>
  <ipo-flexible-table
    [dataSet]="wellData"
    [columns]="columns | translateArray: (language$ | async)! : 'header'"
    [clickableRows]="true"
    (rowClicked)="openWellReportPage($event)"
  >
    <ng-template ipoTableColumn="addressColumn" let-well>
      <div>{{ well.properties.telematorId }} ({{ well.properties.name }})</div>
    </ng-template>
    <ng-template ipoTableColumn="statusColumn" let-well>
      <div>{{ setStatusString(well) }}</div>
    </ng-template>
  </ipo-flexible-table>
</div>
